// @flow
import React from 'react';
import styled, { consolidateStreamedStyles } from 'styled-components';
import Button from './BaseButton';
import { DefaultTheme } from 'trustar-2.0/themes';
import type { ThemeType } from 'trustar-2.0/types';
import { Icon, IconLookup, Spinner } from 'trustar-2.0/components';
import { getButtonColorWithTheme } from '../../themes/common';

const StyledSpinnerButton = styled(Button)`
  && {
    display: inline-flex;
  }

  .sk-spinner {
    color: ${props => getSpinnerColor(props)};
  }
`;

const getSpinnerColor = ({ buttonType, theme, fill }) => {
  const themedColorObject = getButtonColorWithTheme(buttonType, theme);
  return fill === 'outline'
    ? themedColorObject.hex
    : fill === 'none'
    ? theme.ThemeColors.LIGHT.buttonColor
    : themedColorObject.buttonText;
};

type SpinnerButtonPropType = {
  color?: string,
  theme?: ThemeType,
  children?: any,
  isLoading: boolean,
  hideTextOnLoad?: boolean,
};

const SpinnerButton = ({ color, hideTextOnLoad, isLoading, ...props }: SpinnerButtonPropType) => {
  const showText = !isLoading || !hideTextOnLoad;

  return (
    <StyledSpinnerButton {...props}>
      {showText && props.children}
      {isLoading && <Spinner inline={true} bsSize='sm' />}
    </StyledSpinnerButton>
  );
};

export default SpinnerButton;



// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/Button/SpinnerButton.js